import { v4 as uuidv4 } from "uuid";
import config from "../config/global";
import type { QuestionType } from "../config/types";

type ValidateProps = {
  email?: boolean;
  minLength?: number;
  password?: boolean;
  phoneNumber?: boolean;
};

const emailRegExp = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,10}");
const phoneNumberRegExp = new RegExp("07.{8}");

interface FieldValidateProps {
  minLength?: number;
  maxLength?: number;
  mandatory?: boolean;
  optional?: boolean;
  regExp?: RegExp;
}

export const inputValueIsValid = (
  value: any,
  inputValidation: any,
): boolean => {
  const v: FieldValidateProps = inputValidation;

  let ok = true;

  if (!value) {
    return false;
  }

  if (!v) {
    return true;
  }

  if (v.mandatory) {
    const x = typeof value !== "undefined" && value !== null && value !== "";

    if (!x) ok = false;
  }

  if (v.minLength) {
    const x = value?.length >= v.minLength;

    if (!x) ok = false;
  }

  if (v.maxLength) {
    const x = value?.length <= v.maxLength;

    if (!x) ok = false;
  }

  if (v.regExp) {
    //TODO
  }

  return ok;
};

export const validate = (
  value: string,
  { email, minLength, password, phoneNumber }: ValidateProps,
): boolean => {
  if (!value) {
    return false;
  }

  if (email) {
    return emailRegExp.test(value);
  }

  if (password) {
    return value.length >= config.MIN_PASSWORD_LENGTH;
  }

  if (minLength) {
    return value.length >= minLength;
  }

  if (phoneNumber) {
    return phoneNumberRegExp.test(value);
  }

  return true;
};

export const generateRandomID = () => {
  return uuidv4();
};

export const mapKeyToId = (items: any) =>
  items &&
  Object.keys(items)?.map((key: string) => ({
    ...items?.[key],
    id: key,
  }));

export const formatEpoch = (epoch: any) => {
  const d = new Date(epoch * 1000);

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long", // Use 'long' for the full month name as per your requirement
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  return d.toLocaleString("ro-RO", options); // Use 'ro-RO' for Romanian locale
};

export const dateTimeToReadable = (date: any) => {
  const d = new Date(date);

  const pad = (val: any) => String(val).padStart(2, "0");

  return `${pad(d.getHours())}:${pad(d.getMinutes())} - ${pad(
    d.getDate(),
  )}/${pad(d.getMonth())}/${d.getFullYear()}`;
};

export const editableQuestions = (questions: QuestionType[]) =>
  questions.filter(
    (question: QuestionType) => question.visibility.edit === true,
  );
